export function fetchUser(user_id) {
  return fetch(`${process.env.REACT_APP_USERDATA_URI}/user/${user_id}`)
    .then(res => res.json())
    .then(payload => {
      if (!payload) throw new Error("No user found");
      return payload;
    });
}

export function updateUser(user_id, user) {
  return fetch(`${process.env.REACT_APP_USERDATA_URI}/update/user/${user_id}`, {
    method: "POST",
    body: JSON.stringify(user)
  }).then(res => res.json());
}

export default {
  fetchUser,
  updateUser
};



// WEBPACK FOOTER //
// ./src/api/user/index.js